import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut, apiSignUp } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { TOKEN_KEY } from 'utils/helperConstants'
import { NOTIFICATIONS } from 'utils/messages'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const setUserInfo = (user) => dispatch(setUser({ ...user }))

    const signIn = async (values) => {
        let error = {}
        try {
            const resp = await apiSignIn(values)
            if (resp) {
                const {
                    token,
                    firstname,
                    lastName,
                    roles,
                    roleInCompany,
                    vendorId,
                    vendorName,
                    email,
                    profilePictureUrl,
                    phoneNumber,
                    countryCode,
                    vendorVerificationStatus,
                    gstinNumber,
                } = resp
                // localStorage.setItem("token",token)
                if (token) {
                    localStorage.setItem(TOKEN_KEY, token)
                    dispatch(onSignInSuccess(token))
                    setUserInfo({
                        firstName: firstname,
                        lastName,
                        role: roles[0],
                        roleInCompany,
                        gstinNumber,
                        vendorId,
                        companyName: vendorName,
                        workEmail: email,
                        profilePictureUrl,
                        phoneNumber,
                        countryCode,
                        vendorVerificationStatus,
                    })
                    const redirectUrl = query.get(REDIRECT_URL_KEY)
                    navigate(
                        redirectUrl
                            ? redirectUrl
                            : appConfig.authenticatedEntryPath
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                if (!resp.isSuccessful) {
                    return {
                        status: resp.errorCode,
                        message: resp.errorMessage,
                    }
                }
            }
        } catch (errors) {
            error = errors
        }
        return {
            status: 'failed',
            message:
                error?.response?.data?.message ||
                error.toString() ||
                NOTIFICATIONS.SOMETHING_WENT_WRONG,
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                username: '',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        await apiSignOut()
        handleSignOut()
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signUp,
        signOut,
    }
}

export default useAuth
